import { reduxForm, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import TwoFactorAuthFormComponent from './TwoFactorAuthFormComponent';
import { sendTwoFactorAuthCode, AUTH_ERROR } from '../../redux/actions/authActions';
var mapStateToProps = function mapStateToProps(state) {
  return {
    is2FARequired: state.auth.is2FARequired
  };
};
var TwoFactorAuthFormContainer = connect(mapStateToProps)(TwoFactorAuthFormComponent);
var TwoFactorAuthFormContainerForm = reduxForm({
  form: 'twoFactorAuth',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(sendTwoFactorAuthCode(payload.code)).then(function (item) {
      if (item.type === AUTH_ERROR) {
        throw new SubmissionError({
          _error: 'Invalid Auth Code. Please try again.'
          //context.t('Invalid Auth Code. Please try again.')
        });
      }
      return true;
    });
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(TwoFactorAuthFormContainer);
export default TwoFactorAuthFormContainerForm;